import { dedupe } from "./arrays.js";
/**
 * Deep merge two objects.
 *
 * @template T The type of the objects to merge.
 * @param defaults The defaults object.
 * @param data The data object to merge into the defaults.
 * @returns The merged object.
 */
export function deepMerge(defaults, data) {
    Object.keys(defaults).forEach((rawKey) => {
        const key = rawKey;
        const targetValue = data[key];
        const sourceValue = defaults[key];
        if (Array.isArray(targetValue) && Array.isArray(sourceValue)) {
            data[key] = dedupe(sourceValue.concat(targetValue));
        }
        else if (isObject(targetValue) && isObject(sourceValue)) {
            data[key] = deepMerge(sourceValue, Object.assign({}, targetValue));
        }
        else {
            if (data[key])
                return;
            data[key] = sourceValue;
        }
    });
    return data;
}
/**
 * Check if a value is an object.
 *
 * @template T The type of the object.
 * @param obj The value to check.
 * @returns True if the value is an object.
 */
function isObject(obj) {
    return !!(obj && typeof obj === "object" && !Array.isArray(obj));
}
/**
 * Removes any unserializable objects from the object.
 *
 * @template T The type of the object.
 * @param obj The object to flatten.
 * @returns The flattened object.
 */
export function flattenObject(obj) {
    return JSON.parse(JSON.stringify(obj));
}
/**
 * Determines if an object is empty.
 *
 * @param obj The object to check.
 * @returns True if the object is empty.
 */
export function isEmptyObject(obj) {
    for (const prop in obj) {
        if (prop in obj) {
            return false;
        }
    }
    return true;
}
//# sourceMappingURL=objects.js.map